import angular from 'angular';

import tszTeam from './tsz-team';

const tszTeamModule = angular.module('tsz.components.tszTeam', [])
  .component('tszTeam', tszTeam);

export default tszTeamModule;



// WEBPACK FOOTER //
// ./src/components/tsz-team/tsz-team.module.js